import * as React from 'react';
import { useState, useEffect } from "react";
import { DatePicker } from 'rsuite';
import { Tooltip } from 'src/component/Tooltip';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import { useAdminFilterStore } from 'src/hooks/admin/adminFilter';
import System from 'src/helper/system';
import Helper from 'src/support/Helper';
import useReduxState from 'src/hooks/useReduxState';
import {
    ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY,
    ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL,
    ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP,
    isLastLoginDateSearchType,
    shouldDisableAdminUserLastLoginDate
} from 'src/support/AdminLastLoginDateSearch';

export function SearchUser() {
    const [__check] = useAxiosIndicatorCheck();
    const isLastLoginDateSearchEnabled = System.isAdminUserLastLoginDateSearchEnabled();
    const defaultModel = { firstName: "", lastName: "", email: "", lastLoginDate: "" };
    const searchFieldColumnClass = isLastLoginDateSearchEnabled ? "col-sm-12 col-md-3 mb-2" : "col-sm-12 col-md-4 mb-2";
    const searchableFields = [
        { key: 'firstName', searchType: 'First Name', minLength: 2 },
        { key: 'lastName', searchType: 'Last Name', minLength: 2 },
        { key: 'email', searchType: 'Email', minLength: 2 },
        ...(isLastLoginDateSearchEnabled ? [{ key: ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY, searchType: ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL, minLength: 1 }] : [])
    ];
    const [searchData, setSearchData] = useState(defaultModel);
    const [{ filter_list }, { }, { set_filter_list }] = useAdminFilterStore();
    const [userListErrAlert, setUserListErrAlert] = useReduxState("", 'setUserListErrAlert');
    const [errAlertType, setErrAlertType] = useReduxState("", 'setErrAlertType');

    useEffect(() => {
        if (!filter_list || Object.entries(filter_list).length === 0) {
            setSearchData(defaultModel)
        } else {
            const searchingData = { ...defaultModel }
            filter_list?.length > 0 && filter_list?.map((el) => {
                if (el.searchType.trim().toLowerCase() === 'first name') {
                    searchingData['firstName'] = el.searchKeyword
                }
                if (el.searchType.trim().toLowerCase() === 'last name') {
                    searchingData['lastName'] = el.searchKeyword
                }
                if (el.searchType.trim().toLowerCase() === 'email') {
                    searchingData['email'] = el.searchKeyword
                }
                if (isLastLoginDateSearchEnabled && isLastLoginDateSearchType(el.searchType)) {
                    searchingData[ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY] = el.searchKeyword
                }
            })
            setSearchData(searchingData)
        }
    }, [filter_list, isLastLoginDateSearchEnabled]);

    const onSearch = (e) => {
        e.preventDefault();

        const isSearchDataEmpty = searchableFields.every(({ key }) => !Helper.valueIsNotNull(searchData[key]));

        if (isSearchDataEmpty) {
            const errorMessage = isLastLoginDateSearchEnabled
                ? `At least one of the fields (First Name, Last Name, Email, or ${ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL}) should have search keywords to display results`
                : 'At least one of the fields (First Name, Last Name, or Email) should have search keywords to display results';
            setUserListErrAlert(errorMessage, 'danger', 'searchUser');
            setErrAlertType('danger');
            return;
        }

        const filterList = searchableFields
            .map(({ key, searchType, minLength }) => {
                if (!Helper.valueIsNotNull(searchData[key])) {
                    return null;
                }

                const searchKeyword = searchData[key].trim();

                if (searchKeyword.length < minLength) {
                    return null;
                }

                return {
                    searchType,
                    searchKeyword
                };
            })
            .filter(Boolean);

        if (filterList.length === 0) {
            setUserListErrAlert('Minimum 2 characters required for search', 'danger', 'searchUser');
            setErrAlertType('danger');
            return;
        }

        // Clear Alert
        setUserListErrAlert('');
        setErrAlertType('');
        set_filter_list(filterList);
    };

    const onValueChange = (field, value) => {
        setSearchData({ ...searchData, [field]: value });
    }

    return (
        <>
            <div className='bg-grey2'>
                <div className='container'>
                    <div className="accordion-item ">
                        <h2 className="accordion-header" id="searchInput">
                            <button className="accordion-button" type="button" data-toggle="collapse"
                                data-target="#collapseSearch" aria-expanded="true" aria-controls="collapseOne">
                                <b className="font-16">Search</b>
                            </button>
                        </h2>

                        <div id="collapseSearch" className="accordion-collapse collapse in" aria-labelledby="searchInput"
                            data-parent="#accordionExample">
                            <div className="accordion-body p-0">

                                <form onSubmit={(e) => { onSearch(e) }} >
                                    <div className="row bs5 m-t-30 ms-0 me-0 usersearch-container">
                                        <div className={searchFieldColumnClass}>
                                            <label htmlFor="firstName">First Name </label>
                                            <input className="ps-2 form-control form-control-sm mb-0" placeholder="First Name" type="text"
                                                value={searchData.firstName}
                                                onChange={({ target: { value } }) => onValueChange('firstName', value)}
                                            />
                                        </div>


                                        <div className={searchFieldColumnClass}>
                                            <label htmlFor="lastName">Last Name </label>
                                            <input className="ps-2 form-control form-control-sm mb-0" placeholder="Last Name" type="text"
                                                value={searchData.lastName}
                                                onChange={({ target: { value } }) => onValueChange('lastName', value)}
                                            />
                                        </div>

                                        <div className={searchFieldColumnClass}>
                                            <label htmlFor="email">Email </label>
                                            <input className="ps-2 form-control form-control-sm mb-0" placeholder="Email" type="text"
                                                value={searchData.email}
                                                onChange={({ target: { value } }) => onValueChange('email', value)}
                                            />
                                        </div>
                                        {isLastLoginDateSearchEnabled &&
                                            <div className="col-sm-12 col-md-3 mb-2">
                                                <label htmlFor={ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY}>
                                                    {ADMIN_USER_LAST_LOGIN_DATE_SEARCH_LABEL}
                                                    <Tooltip
                                                        position={'bottom center'}
                                                        opener={() => (
                                                            <i
                                                                className="fa fa-info-circle ms-1 font-13 text-black-stone font-16"
                                                                tabIndex="0"
                                                                aria-label={ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP}
                                                            />
                                                        )}
                                                        content={() => ADMIN_USER_LAST_LOGIN_DATE_SEARCH_TOOLTIP}
                                                    />
                                                </label>
                                                <DatePicker
                                                    className="w-100 admin-search-date-picker"
                                                    format={Helper.getDatepickerFormat()}
                                                    placeholder="Month DD, YYYY"
                                                    editable={false}
                                                    oneTap
                                                    shouldDisableDate={shouldDisableAdminUserLastLoginDate}
                                                    value={searchData.lastLoginDate ? new Date(searchData.lastLoginDate) : null}
                                                    onChange={(value) => onValueChange(ADMIN_USER_LAST_LOGIN_DATE_SEARCH_KEY, value ? new Date(value).toISOString() : "")}
                                                />
                                            </div>}
                                    </div>

                                    <div className="row bs5 m-t-20">
                                        <div className="col-sm-12 text-sm-end">
                                            <button className="btn btn-secondary bs5"
                                            // onClick={() => set_find_bom_input_bom_listing(search)}
                                            >Search
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>

    );

}
